var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMax(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 6.2793V4.7793C3 4.38147 3.15804 3.99994 3.43934 3.71864C3.72064 3.43733 4.10218 3.2793 4.5 3.2793H6M3 12.2793V13.7793C3 14.1771 3.15804 14.5587 3.43934 14.84C3.72064 15.1213 4.10218 15.2793 4.5 15.2793H6M12 3.2793H13.5C13.8978 3.2793 14.2794 3.43733 14.5607 3.71864C14.842 3.99994 15 4.38147 15 4.7793V6.2793M12 15.2793H13.5C13.8978 15.2793 14.2794 15.1213 14.5607 14.84C14.842 14.5587 15 14.1771 15 13.7793V12.2793",
    stroke: "#6796CF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMax);
export default __webpack_public_path__ + "static/media/IconMax.c9f0d9d0d715cf1393112a1d74002a61.svg";
export { ForwardRef as ReactComponent };